export class LocalStorageHandler {
    private static HOST_TOKEN = 'hostToken';
    private static HOTEL_TOKEN = 'hotelToken';
    private static CLUSTER_TOKEN = 'clusterToken';
    private static DASHBOARD = 'dashboard';
    private static THEME = 'theme';

    public static getHostToken(): string {
        return localStorage.getItem(this.HOST_TOKEN) ?? '';
    }

    public static getHotelToken(): string {
        return localStorage.getItem(this.HOTEL_TOKEN) ?? '';
    }

    public static getClusterToken(): string {
        return localStorage.getItem(this.CLUSTER_TOKEN) ?? '';
    }

    public static getDashboard(): string {
        return localStorage.getItem(this.DASHBOARD) ?? '';
    }

    public static getTheme(): string {
        return localStorage.getItem(this.THEME) ?? '';
    }

    public static setHostToken(hostToken: string): void {
        localStorage.setItem(this.HOST_TOKEN, hostToken);
    }

    public static setHotelToken(hotelToken: string): void {
        localStorage.setItem(this.HOTEL_TOKEN, hotelToken);
    }

    public static setClusterToken(clusterToken: string): void {
        localStorage.setItem(this.CLUSTER_TOKEN, clusterToken);
    }

    public static setDashboard(dashboard: string): void {
        localStorage.setItem(this.DASHBOARD, dashboard);
    }

    public static setTheme(theme: string): void {
        localStorage.setItem(this.THEME, theme);
    }
}
